




























































import CookieComponent from './CookieComponent'
import { Component, Prop, Watch } from 'vue-property-decorator';

import Popup from '@/components/Popups/Popup.vue'

@Component({
    components: {
        Popup
    },
    model: {
        prop: "model",
        event: "visibilityChanged"
    }
})
export default class CookieDialog extends CookieComponent {

    // Properties
    @Prop({ required: true })
    public model!: boolean;

    // Getter & Setter
    public get visible(): boolean {
        return this.model;
    }
    public set visible(value: boolean) {
        this.fireVisibilityChanged(value);
    }

    // Component Lifecycle Methods:

    // Methods
    public accept(): void {
        this.saveSettings();
        this.executeSettings();
        this.consentRequired = false;
        this.close();
    }

    public close(): void {
        this.visible = false;
    }

    public fireVisibilityChanged(value: boolean): void {
        this.$emit('visibilityChanged', value);
    }
}
